import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '案件管理',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 2,
  staffOnly: true,
};
